import { useTranslation } from "next-i18next";
import { alert } from "../../utils/APICalls/APICalls";
import { AlertErrorType } from "../../utils/ErrorTypes";

export const useTranslationI18 = () => {
  const { t: originalT, ready, i18n } = useTranslation();

  const t = (
    key: string,
    options?: Record<string, string>,
    routerLang?: string,
    name?: string,
    localizedName?: string
  ) => {
    if (routerLang) {
      if (routerLang === "en" && name) {
        return name;
      } else if (localizedName) {
        return localizedName;
      }
    }

    // If translations are not ready (during dynamic component hydration), return key as fallback
    if (!ready) {
      return key;
    }

    const retrieveI18Value = originalT(key, options);

    // Only alert for missing translations when i18n is ready and online
    if (
      retrieveI18Value === key &&
      typeof window !== "undefined" &&
      navigator.onLine &&
      ready
    ) {
      // Only alert if we're online, i18n is ready, and the key is genuinely missing
      alert(`${AlertErrorType.Key_was_not_translated}`, {
        retrieveI18Value,
        key,
      });
    }

    return retrieveI18Value;
  };

  return { t, i18n };
};
